
import {
    SET_INDI_CHALLENGES,
    SET_INDI_CHALLENGE_PARITICIPANTS,
} from './types';

import { apiCallV2 } from "../../utils/api";

export const GetIndiChallenges = (page, count, filter, sort) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "challenges/get-all",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_INDI_CHALLENGES,
        data: {
            list: res.data.indiChallenges,
            count: res.data.count[0]["count(*)"]
        }
    })

}

export const GetIndiChallengeParticipants = (page, count, filter, sort) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "challenges/get-participants",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_INDI_CHALLENGE_PARITICIPANTS,
        data: {
            list: res.data.indiChallengeParticipants,
            count: res.data.count[0]["count(*)"]
        }
    })

}
